import { render, staticRenderFns } from "./Now.vue?vue&type=template&id=36cc4e81&scoped=true"
import script from "./Now.vue?vue&type=script&lang=js"
export * from "./Now.vue?vue&type=script&lang=js"
import style0 from "./Now.vue?vue&type=style&index=0&id=36cc4e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc4e81",
  null
  
)

export default component.exports